const riot = require('riot');

riot.tag2('item-group', '<a class="f bg-white p16" href="/{opts.item.ref.path}"> <div class="rect w128 mr8"><img riot-src="{opts.item.data.image}"></div> <div>{opts.item.data.title}</div></a>', 'item-group,[data-is="item-group"]{display:block}', '', function(opts) {
    this.on('mount', () => {

    });

    this.on('client', ({req, res}) => {

    });

    this.on('server', ({req, res}) => {

    });
});